module.exports = __webpack_public_path__ + "img/chevron-down-sharp-light.0f735e1a.svg";